import { checkMatchingSubsequences } from "../../helpers/DataUpdateHelper";
import InteractionNode from "./InteractionNode";

class InteractionRouteParam {
  set: number;
  parent: number | null; // parent can be null, but is still required
  nodeid: number | null;
  constructor(set: number, parent: number | null, nodeid: number | null) {
    this.set = set;
    this.parent = parent;
    this.nodeid = nodeid;
  }
}

// @TODO/@FIXME - PUT ALL OF THESE INTO MODEL CLASS ITSELF
//  AS STATIC FUNCTIONS, IMPORT STORE TO CHECK STATE AND FIRE DISPATCH
//  (LIKE OTHER MODELS)
export function parseInteractionRouteParams(url: string) {
  const orderedNodes: Array<InteractionRouteParam> = [];
  // if last character is + preview indicator,
  // remove it
  const lastChar = url.at(-1);
  if (lastChar === "+") {
    url = url.substring(0, url.length - 1);
  }
  const treeNodes = url.split("_");
  treeNodes.forEach((treeNode: string) => {
    // check to see if parent included in param
    const entireNode = treeNode.split("p");

    // if no parent, the entire node should just include set
    let thisSet: number | null = null;
    let thisParent: number | null = null;
    let nodeObj: InteractionRouteParam | null = null;
    // if length 1, no parent to handle
    // because array looks something like ['s1'] (length = 1)
    if (entireNode.length === 1) {
      const thisSetArray = entireNode[0].split("s");
      // TODO - need to check if remaining string contains node
      const thisNodeArray = thisSetArray[1].split("n");

      if (thisNodeArray.length === 1) {
        thisSet = parseInt(thisSetArray[1]);
        nodeObj = new InteractionRouteParam(thisSet, null, null);
      } else {
        thisSet = parseInt(thisNodeArray[0]);
        const thisNode = parseInt(thisNodeArray[1]);
        nodeObj = new InteractionRouteParam(thisSet, null, thisNode);
      }
    } else {
      const thisSetArray = entireNode[0].split("s");
      // first value is 's', second value is the set value we need
      thisSet = parseInt(thisSetArray[1]);
      const thisParentArray = entireNode[1].split("p");

      // if n is added to end of nav, need to handle two different cases:
      const thisNodeArray = thisParentArray[0].split("n");
      if (thisNodeArray.length === 1) {
        // in this case, the value we want will be the first one
        thisParent = parseInt(thisParentArray[0]);
        nodeObj = new InteractionRouteParam(thisSet, thisParent, null);
      } else {
        thisParent = parseInt(thisNodeArray[0]);
        const thisNode = parseInt(thisNodeArray[1]);
        nodeObj = new InteractionRouteParam(thisSet, thisParent, thisNode);
      }
    }

    orderedNodes.push(nodeObj);
  });
  return orderedNodes;
}

// check to see if + (preview delimiter) is last string in url
export function doesURLTriggerPreview(url: string) {
  const lastChar = url.at(-1);
  let doesURLTriggerPreview = false;
  if (lastChar === "+") {
    doesURLTriggerPreview = true;
  }
  return doesURLTriggerPreview;
}

export function returnExistingURLForNavigation(url: string) {
  // get entire current URL string from address bar
  let currentURL = url;
  // get the root web address for this app
  // set default
  let appURL = "http://localhost:3001";
  // apply env override
  if (process.env.REACT_APP_URL) {
    appURL = process.env.REACT_APP_URL;
  }
  // remove the default part
  currentURL = currentURL.replace(appURL, "");
  return currentURL;
}

// convert an array of virtual URL params into a useable URL string
export function buildURLStringFromRouteParams(
  params: Array<InteractionRouteParam>,
) {
  let resultString = "";
  console.log(params)
  params.forEach((param: InteractionRouteParam) => {
    resultString += "s" + param.set;
    if (param.parent) {
      resultString += "p" + param.parent;
    }
    resultString += "_";
  });
  // remove trailing _
  if (
    resultString.length > 0 &&
    resultString.charAt(resultString.length - 1) === "_"
  ) {
    resultString = resultString.slice(0, -1);
  }
  return resultString;
}

// convert an array of virtual interaction nodes into a useable URL string
// (FIXME - ARRAY NEEDS TO BE REVERSED EITHER before passing in our after)
export function buildURLStringFromNodesArray(
  interactionNodes: Array<InteractionNode>,
) {
  let resultString = "";

  interactionNodes.forEach((interactionNode: InteractionNode) => {
    resultString += "s" + interactionNode.set_interaction_id;
    if (interactionNode.child_interaction_id) {
      resultString += "p" + interactionNode.child_interaction_id;
    }
    resultString += "n" + interactionNode.id;
    resultString += "_";
  });
  // remove trailing _
  if (
    resultString.length > 0 &&
    resultString.charAt(resultString.length - 1) === "_"
  ) {
    resultString = resultString.slice(0, -1);
  }
  return resultString;
}

export function isNodeAlreadyInNavPath(parentOfCurrentNode:InteractionNode,currentURL:string){
  // Find the index of the second slash
  const secondSlashIndex: number = currentURL.indexOf('/', currentURL.indexOf('/') + 1);
  // Extracting everything after the second slash
  const contentPath: string = currentURL.substring(secondSlashIndex + 1);
  
  const pathNodes: string[] = contentPath.split('_');
  let nodeAlreadyInNavPath = false;
  for (let i = 0; i < pathNodes.length; i++ ){
    const string1 = pathNodes[i];
    const string2 = "s" + parentOfCurrentNode.set_interaction_id + "p" + parentOfCurrentNode.child_interaction_id
    nodeAlreadyInNavPath = checkMatchingSubsequences(string1, string2);
    if(nodeAlreadyInNavPath){
      break;
    }
  }
  return nodeAlreadyInNavPath;
}


export default InteractionRouteParam;
